'use client';

import { css } from '@bts-web/utils-style-engine';
import { ButtonBase, Drawer } from '../../common';
import { useModalDrawerContext } from '../../common/components/ModalDrawerContext/ModalDrawerContext';

interface EstimatedEarningsDrawerProps {
  title: string;
  body: string;
  gotItLabel: string;
}

const EstimatedEarningsDrawer = ({
  title,
  body,
  gotItLabel,
}: EstimatedEarningsDrawerProps) => {
  const { close } = useModalDrawerContext();

  return (
    <Drawer>
      <div
        className={css({
          padding: 'medium',
          display: 'flex',
          flexDirection: 'column',
          gap: 'medium',
          alignItems: 'center',
        })}
      >
        <h4
          className={css({
            fontSize: 'headline.medium_medium',
            fontWeight: 'headline.medium_medium',
            letterSpacing: 'headline.medium_medium',
            lineHeight: 'headline.medium_medium',
            textAlign: 'center',
          })}
        >
          {title}
        </h4>

        <p
          className={css({
            fontSize: 'body.medium',
            lineHeight: 'body.medium',
            letterSpacing: 'body.medium',
            color: 'neutrals.text_primary',
            textAlign: 'center',
          })}
        >
          {body}
        </p>

        <div
          className={css({
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          })}
        >
          <ButtonBase visual="primary" size="large" onClick={() => close()}>
            {gotItLabel}
          </ButtonBase>
        </div>
      </div>
    </Drawer>
  );
};

export { EstimatedEarningsDrawer };
